module.exports = __webpack_public_path__ + "static/media/Practitioners_outcomes.61d48da4.svg";